module.exports = {"serverless":"https://apidev.theplanningtools.com/core","ClientId":"1o5614vvuanltujj78t5mi6tes","UserPoolId":"us-east-1_vDrq5YcxD","IdentityPoolId":"us-east-1:0671b245-fc83-43fd-beaf-42700f3c601f","region":"us-east-1"}


//////////////////
// WEBPACK FOOTER
// ./src/config/ConfigDev.json
// module id = 398
// module chunks = 0